import React, { useState } from 'react'
import { Box } from '@chakra-ui/react'
import { FaFilePen } from 'react-icons/fa6'

import ChatInfoAccordionItem from '../info-accordion-item'
import {
    ChatFieldsFragment,
    useQueryClientFormsQuery,
} from '~graphql/generated/graphql'
import {
    eqBoolFilter,
    eqStringFilter,
    isNullFilter,
} from '~utils/query-helpers'
import InfoLoadingPlaceholder from '../info-loading-placeholder'
import AsyncWrapper from '~components/shared/wrappers/async-wrapper'
import ClientFormItem from './form-item'
import InfoEmptyPlaceholder from '../info-empty-placeholder'

export default function ChatClientDetailsForms({
    chat,
}: {
    chat: ChatFieldsFragment
}) {
    const { client } = chat

    const [isOpen, setIsOpen] = useState(false)

    const { data, loading } = useQueryClientFormsQuery({
        variables: {
            where: [
                eqStringFilter('client', client?.id),
                isNullFilter('client_completed_at', true),
                eqBoolFilter('is_archived', false),
            ],
            page: 0,
            pageSize: 3,
            orderBy: {
                column: 'client_completed_at',
                isAscending: true,
            },
        },
        skip: !client || !isOpen,
    })

    const forms = data?.queryClientForms || []

    return (
        <ChatInfoAccordionItem
            icon={FaFilePen}
            title="Forms"
            isOpenState={isOpen}
            setIsOpenState={setIsOpen}
        >
            <Box px={4} pt={2} pb={3}>
                <AsyncWrapper
                    loading={loading}
                    loadingComponent={<InfoLoadingPlaceholder />}
                    empty={forms.length === 0}
                    emptyComponent={<InfoEmptyPlaceholder item="forms" />}
                >
                    {forms.map(form => (
                        <ClientFormItem
                            key={form.id}
                            chat={chat}
                            clientForm={form}
                        />
                    ))}
                </AsyncWrapper>
            </Box>
        </ChatInfoAccordionItem>
    )
}
